// import "@/assets/js/TCaptcha";
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      captcha: ''
    }
  },
  computed:{
    ...mapGetters(["lang"]),
  },
  created () {
    this.initTencentCaptcha();
  },
  methods: {
    // 初始化tx验证码
    initTencentCaptcha() {
      console.log('==========================', process.env.VUE_APP_TENCENT_APPID)
      // 生成实例对象
      this.captcha = this.$Captcha.init(
        this.tencentCaptchaCallback,{
          forceLang:this.lang === 'CN'?'zh-cn':"en"
        }
      );
      console.log(this.captcha);
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log("腾讯验证码回调：callback", res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr,
        };
        // 调用登陆
        this.sendCode(customParams);

        return res;
      }
      // 验证不成功
      return null;
    },
  }
}